module.exports = __webpack_public_path__ + "media/images/gallery/constellations/orion/ori_dir-ef2c01220f781e12fb4dde054be8b323.png";